import { Space, Popconfirm, Tooltip } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  SaveOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { ButtonCommon } from "components/common";
import { ActionColumnProps, TableRecord } from "types/table.types";
import { Check, X } from "@phosphor-icons/react";

const ActionColumn = <T extends TableRecord>({
  record,
  isEditing,
  edit,
  save,
  cancel,
  deleteRow,
  type,
  onApprove,
  onReject,
}: ActionColumnProps<T>) => {
  return (
    <Space size="small">
      {isEditing ? (
        <>
          <Tooltip title="Lưu">
            <ButtonCommon
              onClick={() => save(record.key)}
              icon={<SaveOutlined className="text-[var(--primaryColor500)]" />}
              color="none"
              className="!px-0"
            ></ButtonCommon>
          </Tooltip>
          <Tooltip title="Hủy">
            <ButtonCommon
              onClick={cancel}
              color="none"
              icon={
                <CloseOutlined className="text-[var(--sematicErrorColor500)]" />
              }
              className="!px-0"
            ></ButtonCommon>
          </Tooltip>
        </>
      ) : type == "CHI_PHI" ? (
        <>
          <div className="flex gap-2">
            <Popconfirm
              title="Từ chối chi phí"
              description="Bạn có chắc chắn muốn từ chối?"
              onConfirm={() => onReject?.(record)}
              okText="Từ chối"
              cancelText="Hủy"
              okButtonProps={{ danger: true }}
            >
              <Tooltip title="Từ chối">
                <ButtonCommon
                  color="dangerSoft"
                  radius="rounded"
                  className="flex justify-center items-center"
                >
                  <X size={20} className="mr-2" />
                  Từ chối
                </ButtonCommon>
              </Tooltip>
            </Popconfirm>

            <Popconfirm
              title="Duyệt chi phí"
              description="Bạn có chắc chắn muốn duyệt?"
              onConfirm={() => onApprove?.(record)}
              okText="Duyệt"
              cancelText="Hủy"
            >
              <ButtonCommon
                color="primary"
                radius="rounded"
                className="flex justify-center items-center"
              >
                <Check size={20} className="mr-2" />
                Duyệt
              </ButtonCommon>
            </Popconfirm>
          </div>
        </>
      ) : (
        <>
          <Tooltip title="Chỉnh sửa">
            <ButtonCommon
              onClick={() => edit(record.key)}
              icon={<EditOutlined />}
              color="none"
              className="!px-0"
            />
          </Tooltip>
          <Popconfirm
            title="Xóa bản ghi"
            description="Bạn có chắc chắn muốn xóa bản ghi này?"
            onConfirm={() => deleteRow(record.key)}
            okText="Xóa"
            cancelText="Hủy"
            okButtonProps={{ danger: true }}
          >
            <Tooltip title="Xóa">
              <ButtonCommon
                icon={
                  <DeleteOutlined className="text-[var(--sematicErrorColor500)]" />
                }
                color="none"
                className="!px-0"
              />
            </Tooltip>
          </Popconfirm>
        </>
      )}
    </Space>
  );
};

export default ActionColumn;
